module.exports = __webpack_public_path__ + "img/copy.fde99d27.svg";